import { render } from "./AppLayout.vue?vue&type=template&id=b731945a"
import script from "./AppLayout.vue?vue&type=script&lang=js"
export * from "./AppLayout.vue?vue&type=script&lang=js"
script.render = render

export default script